import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { ts } from 'src/utils/translate';
import { theme } from 'src/theme/mui-theme';
import { BaseDialog } from 'src/components/BaseDialog/BaseDialog';

type Props = {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    projectName?: string;
};

const ProjectDeleteDialog = ({ open, onClose, onConfirm }: Props) => {
    return (
        <BaseDialog
            open={open}
            onClose={onClose}
            title={ts('warning', 'Warning!')}
            maxWidth="xs"
            actions={
                <Box sx={{ display: 'flex', width: '100%', justifyContent: 'center', gap: '16%' }}>
                    <Button variant="outlined" onClick={onClose} sx={{ minWidth: 100 }}>
                        {ts('plt_cancel', 'Cancel')}
                    </Button>
                    <Button variant="contained" color="error" onClick={onConfirm} sx={{ minWidth: 100 }}>
                        {ts('plt_ok', 'OK')}
                    </Button>
                </Box>
            }
        >
            <Typography sx={{ fontWeight: 300, color: theme.palette.text.secondary, fontSize: 13 }}>
                {ts('type_delete_please_project', 'Confirm deleting project by clicking OK button below')}
            </Typography>
        </BaseDialog>
    );
};

export default ProjectDeleteDialog;
